module.exports = __webpack_public_path__ + "img/icon-delete.c02844b5.svg";